exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".close-btn[data-v-73abb2d0]{position:absolute;right:30px;top:0;height:100%;color:#fff;opacity:1}.close-btn[data-v-73abb2d0]:hover{opacity:.75;color:#fff}.close-btn svg[data-v-73abb2d0]{height:20px}.input-group-text img[data-v-73abb2d0]{width:22px}@media(max-width:1200px){.close-btn[data-v-73abb2d0]{position:absolute;right:25px;top:-3px;height:100%}}", ""]);

// exports
